import { render, staticRenderFns } from "./UpgradePlanModal.vue?vue&type=template&id=4be1b611&"
import script from "./UpgradePlanModal.vue?vue&type=script&lang=js&"
export * from "./UpgradePlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports